import { render } from "./ApiPreloader.vue?vue&type=template&id=55ff6775"
import script from "./ApiPreloader.vue?vue&type=script&lang=js"
export * from "./ApiPreloader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__